import { useState } from 'react';
import webApiClient from '../../Utils/webApiClient';
import { msalInstance } from '../../index';
import config from '../../Config/config';
import useRequestHandler from '../useRequestHandler';

/** Hook is used to read activity by id */
const useReadActivity = () => {

    const { errorHandler, successHandler } = useRequestHandler();
    const apiClient = webApiClient();
    const [ activity, setActivity ] = useState({});

    /** Read activity by id
     * @param {integer} id - id of the activity */
    const readActivity = async (activityId) => {
        try {

            // Account is set in the index.js
            const account = msalInstance.getActiveAccount();

            const response = await msalInstance.acquireTokenSilent({
                scopes: config.webApi.scopes,
                account: account
            });

            // Create resource path
            let resource = "activities/" + activityId.toString();
            
            const result = await apiClient.read(response.accessToken, resource);  

            const data = result && result.data ? result.data : null;
            const resultData = data.resultData || null;
            const content = resultData[0] || null;

            if (content) setActivity(content);

            return successHandler(result, "useReadActivity", "read", { hide: true });

        } catch (error) {
            return errorHandler(error, "useReadActivity", "read");
        }
    }

    return { activity, readActivity };

}

export default useReadActivity;
